import { api } from 'services/companiesApi';
import { Admin } from './AdminDialog.types';

export const postAdmin = async (data: Admin) => {
	return await api.post('/company-users', data);
};

export const putAdmin = async (data: Admin) => {
	return await api.put(`/company-users/${data.id}`, data);
};

export const getRoles = async () => {
	return await api.get('/roles');
};
